import React, { useMemo, useCallback } from 'react';
import useFetchProjectGroups from '@/micros/choose-template/choose-template/components/choose-template-panel/use-fetch-project-groups';
import { selectProjectGroups } from '@/store/slices/project/selectors';
import { useAppSelector } from '@/store/hooks';
import CustomSelect from '@ui/select/custom-select/custom-select';
import Text from '@ui/text/text/text';

interface SelectOption {
  label: string;
  value: string;
}

interface FolderSelectProps {
  onChange: (selectedOptions: SelectOption[]) => void;
  isOpen: boolean;
  isDisabled?: boolean;
  allowMultiSelect?: boolean;
  closeMenuOnSelect?: boolean;
  placeholder?: string;
  label?: string;
}

const FolderSelect = ({
  onChange,
  isOpen,
  isDisabled,
  allowMultiSelect = true,
  placeholder = 'Select Folder',
  label = 'Folder',
}: FolderSelectProps): React.JSX.Element => {
  const folders = useAppSelector(selectProjectGroups);
  const { loading: isLoadingFolders } = useFetchProjectGroups({ skip: !isOpen });

  const selectOptions = useMemo(() => {
    return (folders || []).map((folder) => ({
      label: folder.name,
      value: folder.uuid,
    }));
  }, [folders]);

  const handleSelectChange = useCallback(
    (selected: unknown) => {
      const selectedOptions = Array.isArray(selected) ? selected : [selected];
      onChange(selectedOptions as SelectOption[]);
    },
    [onChange]
  );

  return (
    <div>
      <CustomSelect
        id="event-folder-select"
        permanentDropdownIcon
        RenderHeaderLabelContent={() => <Text className="P2">{label}</Text>}
        isMultiSelect={allowMultiSelect}
        disabled={isLoadingFolders || isDisabled}
        Placeholder={() => placeholder}
        labelHeight="48px"
        options={selectOptions}
        onChange={handleSelectChange}
      />
    </div>
  );
};

export default FolderSelect;
